"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const icon_1 = require("@chakra-ui/icon");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
function createIcon({ displayName, icon, variantIcons, title: defaultTitle }) {
    const FAIcon = (_a) => {
        var { title = defaultTitle, variant } = _a, props = __rest(_a, ["title", "variant"]);
        return ((0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, Object.assign({ icon: (variant && (variantIcons === null || variantIcons === void 0 ? void 0 : variantIcons[variant])) || icon, title: title }, props)));
    };
    FAIcon.displayName = displayName;
    const WrappedIcon = (props) => (0, jsx_runtime_1.jsx)(icon_1.Icon, Object.assign({ as: FAIcon }, props));
    WrappedIcon.displayName = displayName;
    return WrappedIcon;
}
exports.default = createIcon;
